import { refreshManagerService } from "@/business/shared/session/infrastructure/services/refreshManagerService";

export const isRefreshingProcess = {
  execute(): boolean {
    return refreshManagerService.isBusy();
  },
};
